import { Cookie } from '../components/cookie';
import { Metrika } from '../components/metrika';
import { Analytics } from '../components/analytics';

export function testBanner() {
    const cookie = new Cookie;
    const metrika = new Metrika;
    const analytics = new Analytics;

    const banner = document.querySelector('[am-banner="test"]');
    const bannerBtn = document.querySelector('[am-banner-btn="test"]');
    const bannerClose = document.querySelector('[am-banner-close="test"]');

    const burgerBtn = document.querySelector('[am-block="burger"]');
    const burgerMenu = document.querySelector('[am-menu="burger"]');
    const cityBlock = document.querySelector('[am-city="header"]');

    // Проверяем есть ди баннер
    if (!banner) {
        return false;
    }

    if (window.innerWidth < 780) {
        bannerBtn.dataset.target = 'testCard';
    }

    // Функция показывающая баннер
    function showBanner() {
        setTimeout( function() {
            banner.classList.add('is-active');
        }, 1000);
    }

    // Функция скрывающая баннер
    function hideBanner() {
        banner.classList.remove('is-active');
        cookie.set('testWasShown', 1, {domain: 'xn----7sbcf0afblnombxpob1b2b.xn--p1acf'});
    }

    // Баннер появится после закрытия списка городов открытого из модалки geoip на мобильном
    burgerBtn.addEventListener('click' , function() {
        if (!burgerMenu.classList.contains('is-active') && !cookie.get('testWasShown')) {
            showBanner();
        }
    });

    // Баннер появится после закрытия списка городов открытого из модалки geoip на десктопе
    cityBlock.addEventListener('mouseleave', function() {
        if (!cookie.get('testWasShown')) {
            showBanner();
        }
    });

    // Обработчик кнопки в баннере
    bannerBtn.addEventListener('click', function() {
        hideBanner();
        // Счетчики
        metrika.reachGoal('TEST_BUTTON_BANNER', this);
        analytics.event('TEST_BUTTON_BANNER', this);
    });

    // Обработчик крестика в баннере
    bannerClose.addEventListener('click', function() {
        hideBanner();
    });

    // Проверяем активно ли модальное окно geoip
    // Если нет показываем баннер
    if (!cookie.get('isCityCorrect') || cookie.get('testWasShown')) {
        return false
    }

    showBanner();

}